import { z } from 'zod';
import { shiftParticipantHoursHistorySchema, } from '../shared/entities/shiftParticipantHoursHistoryTypes';
const deleteVolunteeringHoursParamsSchema = z.object({
    participationIds: z.string().uuid().array(),
});
const deleteVolunteeringHoursSchema = z.object({
    id: z.string().uuid(),
    data: shiftParticipantHoursHistorySchema.optional(),
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
});
const partialdeleteVolunteeringHoursResponseSchema = deleteVolunteeringHoursSchema.omit({
    columns: true,
});
export const deleteVolunteeringHoursFunctionDef = {
    name: 'deleteVolunteeringHours',
    requestSchema: deleteVolunteeringHoursParamsSchema,
    responseSchema: deleteVolunteeringHoursSchema.array(),
};
